import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

function WorkshopCancellation() {
  const { token } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [cancelled, setCancelled] = useState(false);

  useEffect(() => {
    if (token) {
      fetch(`/api/public/workshop-booking/${token}`)
        .then(res => res.json())
        .then(data => {
          setLoading(false);
          if (data.message === 'success') {
            setBooking(data.data);
          } else {
            setError(data.error || 'Buchung nicht gefunden');
          }
        })
        .catch(err => {
          setLoading(false);
          setError('Verbindungsfehler');
        });
    }
  }, [token]);

  const handleCancel = () => {
    if (!window.confirm('Moechtest du deine Anmeldung wirklich stornieren?')) {
      return;
    }

    setCancelling(true);
    fetch(`/api/public/workshop-cancel/${token}`, {
      method: 'POST'
    })
      .then(res => res.json())
      .then(data => {
        setCancelling(false);
        if (data.message === 'success') {
          setCancelled(true);
        } else {
          setError(data.error || 'Fehler bei der Stornierung');
        }
      })
      .catch(err => {
        setCancelling(false);
        setError('Verbindungsfehler');
      });
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
        <p className="mt-3">Buchung wird geladen...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card border-danger">
            <div className="card-body text-center py-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="text-danger mb-4" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
              </svg>
              <h4 className="text-danger mb-3">{error}</h4>
              <p className="text-muted mb-4">
                Die Buchung wurde moeglicherweise bereits storniert oder der Link ist ungueltig.
              </p>
              <Link to="/events" className="btn btn-primary">
                Zu den Events
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (cancelled) {
    return (
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card border-success">
            <div className="card-body text-center py-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="text-success mb-4" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
              </svg>
              <h4 className="text-success mb-3">Stornierung erfolgreich</h4>
              <p className="text-muted mb-4">
                Deine Anmeldung wurde storniert. Du erhaeltst eine Bestaetigung per E-Mail.
              </p>
              <Link to="/events" className="btn btn-primary">
                Weitere Events ansehen
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-6">
        <div className="card">
          <div className="card-header bg-warning text-dark">
            <h5 className="mb-0">Anmeldung stornieren</h5>
          </div>
          <div className="card-body">
            <p className="mb-4">Moechtest du folgende Anmeldung wirklich stornieren?</p>

            <div className="bg-light rounded p-3 mb-4">
              <h5 className="mb-2">{booking.workshop_title}</h5>
              <p className="mb-1">
                <strong>Datum:</strong> {formatDate(booking.workshop_date)}
              </p>
              <p className="mb-1">
                <strong>Uhrzeit:</strong> {booking.workshop_time?.substring(0, 5)} Uhr
              </p>
              {booking.location && (
                <p className="mb-1">
                  <strong>Ort:</strong> {booking.location}
                </p>
              )}
              <p className="mb-1">
                <strong>Name:</strong> {booking.name}
              </p>
              {booking.participants > 1 && (
                <p className="mb-0">
                  <strong>Teilnehmer:</strong> {booking.participants}
                </p>
              )}
            </div>

            <div className="d-grid gap-2">
              <button
                className="btn btn-danger btn-lg"
                onClick={handleCancel}
                disabled={cancelling}
              >
                {cancelling ? 'Wird storniert...' : 'Ja, Anmeldung stornieren'}
              </button>
              <Link to="/events" className="btn btn-outline-secondary">
                Abbrechen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkshopCancellation;
